module.exports = __webpack_public_path__ + "img/theme2.68f0122c.png";